<template>

    <div class="form-group" :class="{ centered }" :id="identifier">
        <label v-if="label">
            <i v-if="icon" :class="icon" class="mr-5" />
            <span><span v-html="label" /><span v-if="required">*</span></span>
            <span v-if="url" class="action ml-5"><a :href="url" target="_blank"><i class="far fa-circle-info" /></a></span>
            <span v-else-if="route" class="action ml-5"><router-link :to="route"><i class="far fa-circle-info" /></router-link></span>
            <span v-else-if="secondaryAction" class="action ml-5" @click="secondaryAction"><i :class="secondaryIcon" /></span>
            <v-badge-upgrade v-if="locked" size="sm" :feature="feature" class="ml-5" />
            <v-badge-new v-else-if="date" :date="date" size="sm" class="ml-5" />
        </label>
        <slot></slot>
        <span v-if="caption" class="caption">
            <i v-if="captionIcon" :class="captionIcon" class="mr-5" />
            <span v-html="caption" />
        </span>
        <div v-else-if="$slots['caption']" class="caption">
            <i v-if="captionIcon" :class="captionIcon" class="mr-5" />
            <slot name="caption"></slot>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .form-group {
        margin: 0 0 20px 0;
        padding: 0;
        text-align: left;
        > span {
            color: $color-text;
        }
        label {
            @include font-medium(13px);
            color: $color-text;
            display: flex;
            align-items: center;
            line-height: normal;
            margin: 0 0 10px 0;
            padding: 0;
        }
        .action {
            cursor: pointer;
        }
        .caption {
            @include font-medium(13px);
            color: $color-muted;
            display: block;
            margin-top: 10px;
            text-align: left;
            &.caption-danger::before {
                content: "•";
                color: $color-danger;
            }
            &.caption-success {
                color: $color-success;
            }
        }
        p {
            @include font-medium(14px);
            margin: 0;
            padding: 0;
        }
        &.centered {
            text-align: center;
            label {
                justify-content: center;
            }
            .caption {
                text-align: center;
            }
        }
    }

</style>

<script>

import BadgeNew from '@cmp/BadgeNew';
import BadgeUpgrade from '@cmp/BadgeUpgrade';
import StringUtil from '@utils/StringUtil';

export default {

    components: {
        'v-badge-new': BadgeNew,
        'v-badge-upgrade': BadgeUpgrade,
    },

    props: {
        icon: {
            type: String,
        },
        label: {
            type: String,
        },
        required: {
            type: Boolean,
            default: false,
        },
        caption: {
            type: String,
        },
        captionIcon: {
            type: String,
        },
        centered: {
            type: Boolean,
            default: false,
        },
        // Used for secondary actions.
        url: {
            type: String,
        },
        route: {
            type: Object,
        },
        secondaryAction: {
            type: Function,
        },
        secondaryIcon: {
            type: String,
            default: 'fas fa-delete-left',
        },
        // Used for new flag.
        date: {
            type: String,
            validator: function(value) {
                return /^\d{4}-\d{2}-\d{2}$/.test(value);
            },
        },
        // Used for upgrading.
        locked: {
            type: Boolean,
            default: false,
        },
        feature: {
            type: String,
        },
    },

    computed: {

        identifier() {
            return StringUtil.identifier(this.label, 'label-');
        },

    },

}

</script>
